'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var browser = {
  isSafari: function isSafari() {
    var vendor = navigator.vendor,
        userAgent = navigator.userAgent;
    return vendor && vendor.indexOf('Apple') > -1 && userAgent && !userAgent.match('CriOS');
  }
};
exports.default = browser;